import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  IconButton,
  Box,
  TextField,
} from '@mui/material';
import {
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
} from '@mui/icons-material';
import { DatePicker } from '@mui/x-date-pickers';
import { addMonths, subMonths } from 'date-fns';

const PointageFilters = ({
  users,
  selectedUser,
  selectedDate,
  onUserChange,
  onDateChange,
  disabled,
}) => {
  const handlePreviousMonth = () => {
    onDateChange(subMonths(selectedDate, 1));
  };

  const handleNextMonth = () => {
    onDateChange(addMonths(selectedDate, 1));
  };

  return (
    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', minWidth: 300 }}>
      <FormControl size="small" sx={{ width: 200 }}>
        <InputLabel>Utilisateur</InputLabel>
        <Select
          value={selectedUser}
          label="Utilisateur"
          onChange={(e) => onUserChange(e.target.value)}
          disabled={disabled}
        >
          {users.map((user) => (
            <MenuItem key={user.id} value={user.id}>
              {user.full_name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <IconButton size="small" onClick={handlePreviousMonth}>
          <ChevronLeftIcon />
        </IconButton>
        <DatePicker
          label="Mois"
          views={['month', 'year']}
          value={selectedDate}
          onChange={onDateChange}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="standard"
              size="small"
              sx={{ width: 120 }}
            />
          )}
        />
        <IconButton size="small" onClick={handleNextMonth}>
          <ChevronRightIcon />
        </IconButton>
      </Box>
    </Box>
  );
};

export default PointageFilters;
